<template>
	<div>
		<div v-show="fileShow" id="party-file">
			<van-pull-refresh v-model="isRefresh" @refresh="onRefresh">
				<van-list v-model="isLoading" :finished="isFinished" @load="onLoad">
					<div v-for="item in list" :key="item.id">
						<div class="item">
							<van-row type="flex" justify="space-between">
								<div class="name" @click="doCopy(item.url)">{{ item.name }}</div>
								<van-icon name="down" color="#1592E6" size="18px" @click="download(item.url)" />
							</van-row>
						</div>
						<van-divider class="divider" />
					</div>
				</van-list>
			</van-pull-refresh>
		</div>
		<div v-show="!fileShow" style="color: #5f5b5b; font-size: 20px">暂无文件</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Toast } from 'vant'

export default {
	props: ['tabId'],
	data() {
		return {
			list: [],
			isRefresh: false,
			isLoading: false,
			isFinished: false,
			isOpen: false,
			scrUrl: '',
			fileShow: true,
		}
	},

	computed: {
		...mapGetters(['token', 'userId', 'communityId']),
	},
	watch: {
		tabId() {
			this.onLoad()
		},
	},
	methods: {
		onRefresh() {
			this.list = []
			this.onLoad()
			this.$toast('刷新成功')
			this.isRefresh = false
		},
		onLoad() {
			if (this.tabId != 2) {
				return
			}
			this.list = []
			this.vaxios.get(
				`${this.vaxios.host}/open/api/v1/party-histories/status/published`,
				{
					communityId: this.communityId,
				},
				(res) => {
					if (!res.data) {
						this.contentShow = false
						return
					}

					this.isLoading = false
					this.isFinished = true
					this.contentShow = true
					let attachs = res.data.attachs
					attachs.forEach((item) => {
						item.attach_type === 2 &&
							this.list.push({
								id: item.id,
								name: item.attach_name,
								url: item.attach_url,
							})
					})
				},
				function(err) {
					console.log(err)
				}
			)
		},
		download(url) {
			window.location.href = url
		},
		doCopy(res) {
			this.$copyText(res).then(
				() => {
					Toast.success('下载地址已复制到剪贴板')
				},
				() => {
					Toast.fail('下载地址复制失败')
				}
			)
		},
	},
}
</script>

<style scoped>
#party-file {
	height: 100%;
	background-color: #f5f5f5;
	padding-top: 0.75rem;
}

.item {
	padding: 0.78125rem 1rem 0.8125rem 1rem;
	background-color: #ffffff;
}

.item .name {
	color: #272727;
	font-size: 0.875rem;
	width: 90%;
}

.pdfClass {
	background-color: white;
	position: absolute;
	z-index: 999;
	top: 35%;
	width: 100%;
	height: 100%;
	left: 0;
	right: 0;
}

.divider {
	margin: 0;
}
</style>
